export const formatPhone = (
  phone: string,
  shouldUSFormat?: boolean
): string => {
  if (!phone) return '';

  const digits = phone.replace(/\D/gu, '');

  // US: +1 (XXX) XXX-XXXX
  if (digits.length === 11 && digits.startsWith('1')) {
    return `(${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  }

  // US: (XXX) XXX-XXXX (10-digit without country code)
  if (shouldUSFormat && digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }

  // International: +XX XXX XXX XXXX
  if (digits.length > 10) {
    return `${digits.slice(0, 2)} ${digits.slice(2, 5)} ${digits.slice(5, 8)} ${digits.slice(8)}`;
  }

  return phone;
};
